"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledPrice = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _localization = require("@lt/localization");

var _CurrencyFormat = _interopRequireDefault(require("../CurrencyFormat"));

var _excluded = ["price", "noStickers"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var HotelOfferPrice = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var price = _ref.price,
      noStickers = _ref.noStickers,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useCurrency = (0, _localization.useCurrency)(),
      code = _useCurrency.code;

  return /*#__PURE__*/_react["default"].createElement(StyledHotelOfferPrice, (0, _extends2["default"])({}, rest, {
    noStickers: noStickers
  }), /*#__PURE__*/_react["default"].createElement(StyledPrice, {
    value: price,
    currencyCode: code
  }));
});

HotelOfferPrice.displayName = 'HotelOfferPrice';
HotelOfferPrice.propTypes = {
  price: _propTypes["default"].number.isRequired
};
var StyledPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelOfferPrice__StyledPrice",
  componentId: "sc-1v3l0l6-0"
})(["", " color:black;"], function (props) {
  return props.theme.typography.headline3;
});
exports.StyledPrice = StyledPrice;

var StyledHotelOfferPrice = _styledComponents["default"].div.withConfig({
  displayName: "HotelOfferPrice__StyledHotelOfferPrice",
  componentId: "sc-1v3l0l6-1"
})(["display:flex;align-items:center;", ""], function (_ref2) {
  var noStickers = _ref2.noStickers;
  return noStickers && (0, _styledComponents.css)(["justify-content:center;"]);
});

var _default = HotelOfferPrice;
exports["default"] = _default;